<div class="ri-p-6">
    <h5 class="text-16-500 color-8 ri-pb-4">{{ ss.t('supportChatInstructions_title') }}</h5>

    <div class="instruction-content">
        <ul class="instruction-list text-14-400 color-7 ri-pb-4 mb-0 ri-ms-4" style="list-style: disc;">
            <li class="ri-pb-1">{{ ss.t('supportChatInstructions_content1') }}</li>
            <li class="ri-pb-1">{{ ss.t('supportChatInstructions_content2') }}</li>
            <li>{{ ss.t('supportChatInstructions_content3') }}</li>
        </ul>
    </div>

    <div class="flex justify-end">
        <button class="btn btn-text color-35" (click)="closeDialog()">{{ ss.t('common_ok') }}</button>
    </div>
</div>